import { Client } from "../client/client";
import { Usuario } from "../usuario/usuario";
import { TipoTicketEnum } from "src/app/enum/tipoTicket.enum";
import { StatusTicketEnum } from "src/app/enum/statusTicket.enum";
import { PrioridadeEnum } from "src/app/enum/prioridade.enum";
import { NotaTicket } from "./nota";
import { ImagemBase64 } from "src/app/model/imagemBase64";

export class Ticket {   
    id: number; 
    parceiro: Client;
    createdAt: any;
    usuario: string;
    abertoPor?: string | null;
    menu: string;
    subMenu: string;
    tipo: TipoTicketEnum;
    segmento: string;
    prioridade: PrioridadeEnum;
    status: StatusTicketEnum;
    apresentarParceiro:boolean;
    responsavelSuporte: string;
    responsavelDesenvolvimento: string;
    nota: NotaTicket[];
    dataPrevisaoEntrega: any;
    datConclusaoEntrega: any;
    dataConfirmacaoEntrega: any;
    dataFinalizacao: any;
    texto: string; 
    tempoEstimadoMinutos?: number | null;
    tempoEstimadoBloqueado?: boolean;
    tempoGastoSegundos?: number | null;
    cronometroInicio?: any;
    imagensBase64?: ImagemBase64[];

constructor(id: number, parceiro: Client, createdAt: any, usuario: string, menu: string, subMenu: string, tipo: TipoTicketEnum, segmento: string, prioridade: PrioridadeEnum, status: StatusTicketEnum, apresentarParceiro:boolean,
    responsavelSuporte: string, responsavelDesenvolvimento: string, nota: NotaTicket[], dataPrevisaoEntrega: any,
    datConclusaoEntrega: any, dataConfirmacaoEntrega: any, dataFinalizacao: any, texto: string, imagensBase64?: ImagemBase64[]) {
            this.id = id;
            this.parceiro = parceiro;
            this.createdAt = createdAt;
            this.usuario = usuario;
            this.menu = menu;
            this.subMenu = subMenu;
            this.tipo = tipo;
            this.prioridade = prioridade;
            this.segmento = segmento;
            this.status = status;
            this.apresentarParceiro = apresentarParceiro;
            this.responsavelSuporte = responsavelSuporte;
            this.responsavelDesenvolvimento = responsavelDesenvolvimento;
            this.nota = nota;
            this.dataPrevisaoEntrega = dataPrevisaoEntrega;
            this.datConclusaoEntrega = datConclusaoEntrega;
            this.dataConfirmacaoEntrega = dataConfirmacaoEntrega;
            this.dataFinalizacao = dataFinalizacao;
            this.texto = texto;
            this.imagensBase64 = imagensBase64;
        }
    }